import { Outlet, Link, useLocation, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LogoutIcon, HomeIcon, UsersIcon, TeamIcon, SettingsIcon, UserIcon, CalendarIcon } from '../Icons/Icons';
import Logo from '../Logo/Logo';
import NotificationBell from '../Notifications/NotificationBell';
import { getStaticUrl } from '../../api/client';
import './Layout.css';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, isAuthenticated, isManager, isResponsable, isCEO, isCOO, isAdminRole, isCoach, loading, hasPermission } = useAuth();

  // Attendre que le chargement soit terminé avant de rediriger
  if (loading) {
    return <div style={{ color: 'white', padding: '2rem' }}>Chargement...</div>;
  }

  // Si non authentifié, rediriger vers login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Items de navigation en fonction des permissions
  const navItems = [
    { path: '/accueil', label: 'Accueil', icon: <HomeIcon size={18} />, show: true },
    { path: '/events', label: 'Événements', icon: <CalendarIcon size={18} />, show: true },
    { path: '/membres', label: 'Membres', icon: <UsersIcon size={18} />, show: hasPermission('players.view_all') },
    { path: '/equipes', label: 'Équipes', icon: <TeamIcon size={18} />, show: hasPermission('teams.create') || hasPermission('teams.edit') },
    { path: '/admin', label: 'Administration', icon: <SettingsIcon size={18} />, show: hasPermission('admin.access') },
  ];

  const filteredNavItems = navItems.filter(item => item.show);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <div className="layout-blob layout-blob-1" />
      <div className="layout-blob layout-blob-2" />
      <aside className="sidebar">
        <div className="sidebar-header">
          <Logo variant="sidebar" size="medium" />
          <div className="user-info">
            <div className="user-avatar-container">
              {user?.avatar && (
                <img src={getStaticUrl(user.avatar)} alt={user.username} className="user-avatar" />
              )}
              {!user?.avatar && (
                <div className="user-avatar-placeholder">{user?.username?.charAt(0).toUpperCase()}</div>
              )}
            </div>
            <div className="user-details">
              <span className="user-name">{user?.username}</span>
              <span className="user-role">
                {isAdminRole() ? '🔐 Admin' : isCEO() ? '🌟 CEO' : isCOO() ? '🌟 COO' : isResponsable() ? '⭐ Responsable' : isManager() ? '👑 Manager' : isCoach() ? '🎓 Coach' : '🎮 Joueur'}
              </span>
            </div>
            <NotificationBell />
            <div className="sidebar-footer">
              <Link to="/profil" className={`btn-profile ${location.pathname === '/profil' ? 'active' : ''}`}>
                <span><UserIcon size={18} /></span> Mon Profil
              </Link>
              <button onClick={handleLogout} className="btn-logout">
                <LogoutIcon size={18} /> Déconnexion
              </button>
            </div>
          </div>
        </div>
        <nav>
          {filteredNavItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={location.pathname === item.path ? 'active' : ''}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="sidebar-footer">
          <Link to="/profil" className={`btn-profile ${location.pathname === '/profil' ? 'active' : ''}`}>
            <span><UserIcon size={18} /></span> Mon Profil
          </Link>
          <button onClick={handleLogout} className="btn-logout">
            <LogoutIcon size={18} /> Déconnexion
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
